import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationMonthlyInvoice = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationMonthlyInvoice',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70186)",
    fillRule: "evenodd",
    d: "M84 97.35H16c-5.52 0-10-4.877-10-10.885v-74.02c0-2.405 1.79-4.354 4-4.354h80c2.21 0 4 1.949 4 4.354v74.02c0 6.008-4.48 10.885-10 10.885Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1DA3AA",
    fillRule: "evenodd",
    d: "M37.77 97.35H16c-5.52 0-10-4.877-10-10.885V60.612s5.49 15.599 12.8 23.665c7.31 8.088 18.97 13.073 18.97 13.073Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E36A98",
    fillRule: "evenodd",
    d: "m73.634 59.427-4.82-4.105-9.41 10.961-4.61-4.529-4.457 4.493 9.465 9.293 13.832-16.113Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E36A98",
    fillRule: "evenodd",
    d: "M61.983 79.899c8.584 0 15.542-6.93 15.542-15.48 0-8.549-6.958-15.48-15.542-15.48-8.583 0-15.541 6.931-15.541 15.48 0 8.55 6.958 15.48 15.541 15.48Zm0 6.315c12.086 0 21.882-9.758 21.882-21.795 0-12.037-9.796-21.795-21.881-21.795-12.086 0-21.882 9.758-21.882 21.795 0 12.037 9.796 21.795 21.882 21.795Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70186)",
    fillRule: "evenodd",
    d: "M37.77 97.35C28.88 92.147 31 70.54 31 70.54s-18.41 6.422-25-9.514c0 0-.35 10.602 11.19 23.664 11.54 13.063 20.58 12.66 20.58 12.66Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70186)",
    fillRule: "evenodd",
    d: "M94 25.431H6V12.445c0-2.405 1.79-4.354 4-4.354h80c2.21 0 4 1.949 4 4.354v12.986Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E36A98",
    fillRule: "evenodd",
    d: "M70.36 2.649c-1.9 0-3.45 1.676-3.45 3.755v5.562c0 2.069 1.54 3.756 3.45 3.756 1.9 0 3.45-1.676 3.45-3.756V6.404c0-2.079-1.55-3.755-3.45-3.755ZM29.55 2.649c-1.9 0-3.45 1.676-3.45 3.755v5.562c0 2.069 1.54 3.756 3.45 3.756 1.9 0 3.45-1.676 3.45-3.756V6.404c0-2.079-1.54-3.755-3.45-3.755Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70186",
    x1: 71.113,
    x2: 13.441,
    y1: 10.168,
    y2: 102.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.02,
    stopColor: "#B2F7FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.183,
    stopColor: "#99EDF5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.918,
    stopColor: "#2CC0CA"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70186",
    x1: 7.106,
    x2: 25.606,
    y1: 100.263,
    y2: 77.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.285,
    stopColor: "#2CC0CA"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.829,
    stopColor: "#B2F7FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#C9FAF9"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70186",
    x1: 49.697,
    x2: 50.787,
    y1: 33.815,
    y2: -11.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.285,
    stopColor: "#E36A98"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#C9FAF9"
  }))));
};
ColoredIllustrationMonthlyInvoice.displayName = 'ColoredIllustrationMonthlyInvoice';
export default withProvisionalOverrideFromContext(ColoredIllustrationMonthlyInvoice);
//# sourceMappingURL=index.js.map